import { AllRmPriceListResponse, RmPriceListResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { RmPriceListDTO } from './dto/rm-price-list.dto';
import { RmPriceListRequest } from './dto/rm-price-list.request';
import { RmPriceListService } from './rm-price-list.service';

@Controller('rm-price-list')
export class RmPriceListController {

    constructor(
        private rmPriceListService: RmPriceListService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}
 /**
     * creates  a Rm PriceList
     * @param RmPriceListDto RmPriceList DTO
     * @returns  rmPriceListResponse
     */
  @Post('/createRmPriceList')
  async createRmPriceList(@Body() rmPriceListDTO:RmPriceListDTO, @Req() request:Request): Promise<RmPriceListResponse> {
      try {
       return await this.rmPriceListService.createRmPriceList(rmPriceListDTO,false,request);
     } catch (error) {
          return this.applicationExceptionHandler.returnException(RmPriceListResponse, error);
     }
   }

    /**
     * gets all the Value rm PriceList
     * @returns AllRmPriceListResponse which returns all the Value rm-PriceList  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

     @Post('/getAllRmPriceList')
    async getAllRmPriceList(): Promise<AllRmPriceListResponse> {
        try {
            return await this.rmPriceListService.getAllRmPriceList();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllRmPriceListResponse, error);
        }
    }

      /**
     * Activate Or De-Activate Value rmPriceList
     * @param getSingleRmPriceList rmPriceList
     * @returns Value RmPriceList
     */

       @Post('/activateOrDeactivateRmPriceList')
       async activateOrDeactivateRmPriceList(@Body() rmPriceListReq: RmPriceListRequest): Promise<RmPriceListResponse> {
           try {
               return await this.rmPriceListService.activateOrDeactivateRmPriceList(rmPriceListReq);
           } catch (err) {
               return this.applicationExceptionHandler.returnException(RmPriceListResponse, err);
           }
       }
       /**
     *  updates a  value rm PriceList
     * @param RmPriceListDto Rm PriceList DTO
     * @returns RmPriceListResponse
     */

        @Post('/updateRmPriceList')
    async updateRmPriceList(@Body() rmPriceListDTO:RmPriceListDTO, @Req() request:Request): Promise<RmPriceListResponse> {
        try {
         return await this.rmPriceListService.createRmPriceList(rmPriceListDTO,true,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(RmPriceListResponse, error);
       }
     }
}
